export default {
  tips: 'It is recommended to use Google Chrome browser for the best experience',
  account: 'Username',
  pwd: 'Password    ',
  confirmPwd: 'Confirm password',
  areaCode: 'Country',
  email: 'Email',
  phone: 'Phone number',
  code: 'Verification code',
  sellerType: 'Seller Type',
  company: 'Company',
  personal: 'Individual',
  telephone: 'Landline',
  fax: 'Fax',
  reluMsgAccount: 'Letters and numbers supported, at least 4 in length    ',
  reluMsgRegistered: 'Sorry, the account has been registered',
  reluMsgPwd: 'At least 6 in length    ',
  reluMsgConfirmPwd: 'Please input same password    ',
  reluMsgareaCode: 'Please select country',
  reluMsgEmail: 'Please enter correct email',
  reluMsgPhone: 'Please enter correct phone number',
  reluMsgCode: 'Please enter verification code',
  reluMsgCheckCode: 'Verification code error',
  checkFaild: 'Verification code verification failed',
  reluMsgCheckSN: 'Please get the SMS verification code first',
  reluMsgMerchantType: 'Please select seller type',
  reluMsgTelephone: '',
  reluMsgFax: '',
  successText: 'Verification passed!',
  failText: 'Verification failed, please try again',
  sliderText: 'Drag Slider Puzzle',
  businessIfYou: 'Business (if you are a registered or incorporated company with acceptable documents.)',
  individualIfYou: 'Individual (if you are a seller without any registered or incorporated company.)',
  fillInPhoneNumber: 'Fill in phone number',
  useToReceiveAccountRelated: 'Used to receive account-related notifications',
  referralCode: 'Referral Code',
  oauthLoginTitle: 'Currently logged in as: {account} (Consumer Account)',
  oauthLoginDesc: 'The merchant account to be created will be directly linked to this account.',
  oauthBindTitle: 'Reminder: Upon submission, the merchant role will be bound to the consumer account {account}.',
  oauthBindDesc: 'You can manage both consumer and merchant permissions with a single global account.',
  existingAccountTitle: 'This account already has a merchant account: {account}',
  existingAccountQuestion: 'Do you want to log in directly?',
  existingAccountCancel: 'Cancel',
  existingAccountConfirm: 'Confirm',
  existingAccountConfirmTip: 'Login action is pending.',
  idNumSupportLettersAndDigits: 'ID number support letters and digits only.'
}
